import qs from 'query-string';
import { apiConfig } from '@/services/api-config';

export default async function (document: string, CAR: string, name = '') {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);

  const { idUser } = userLogged;
  const { stKey } = userLogged.company;

  const query = qs.stringify({
    document,
    tokenKey: stKey,
    name,
    CAR,
    frigId: idUser,
  }, { skipNull: true });

  return apiConfig
    .get(`api/territory/get-by-agent-document-car?${query}`)
    .then((response) => {
      const { objectResult } = response.data;

      return objectResult;
    })
    .catch((err) => ({ hasErrors: true, err }));
}
